exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".compute-content-area {\n  padding-top: 24px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/compute/compute-vc/dashboard-vc/compute-dashboard-vc.scss
// module id = Ub92
// module chunks = 0